<template>
  <div>
    <h2>Counter Signer Settings</h2>
    <div class="form-group">
      <div class="checkbox checkbox-primary">
        <input type="checkbox" class="styled" name="counter-signer" v-model="formData.isCounterSigner" @change="clearSelectedOfferings">
        <label>Counter Signer</label>
        <modal-help>
          Check the "counter signer" box to give this user the counter signer role.
          Choose at least one offering and then click confirm.
          Uncheck this box and click Confirm to remove counter signer role.
        </modal-help>
      </div>
    </div>
    <div>
      <offering-list :offerings="offerings" @checkbox="getOfferings" v-if="formData.isCounterSigner" :admin-offerings="counterSignerOfferings"></offering-list>
      <input type="button" name="counterSignerBtn" value="Confirm" @click="updateUser" class="btn btn-default margin-right-10" :disabled="formData.isCounterSigner && toggleConfirm"/>
      <h5 v-show="isVisible">{{ message }}</h5>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import OfferingList from "./OfferingList"
  import ModalHelp from "./ModalHelp";

  export default {
    name: "CounterSignerEdit",
    components: {
      ModalHelp,
      OfferingList,
    },
    props: {
      offerings: {
        type: Array,
        default: [],
      },
      userId: {
        type: Number,
        default: 0
      },
      isCounterSigner: {
        type: Boolean,
        default: false
      },
      counterSignerOfferings: {
        type: Array,
        default: []
      }
    },
    data() {
      return {
        isVisible: false,
        message: '',
        formData: {
          isCounterSigner: this.isCounterSigner,
          user_id: this.userId,
          selectedOfferings: [],
        },
      }
    },
    methods: {
      updateUser() {
        axios.post('setCounterSigner', this.formData)
          .then(response => {
            this.message = response.data.status
            this.isVisible = true
            this.timer()
          })
          .catch(error => {
            console.error('Error updating counter signer:', error)
            this.message = 'There is an error updaing counter signer'
          })
      },
      getOfferings(data) {
        this.formData.selectedOfferings = data.slice(0)
      },
      clearSelectedOfferings() {
        if (!this.formData.isCounterSigner) {
          this.formData.selectedOfferings = []
        }
      },
      timer() {
        setTimeout(() => {
          this.isVisible = false
          this.message = ''
        }, 3000)
      }
    },
    computed: {
      toggleConfirm() {
        return !(this.formData.selectedOfferings.length >= 1);
      }
    },
    mounted() {
      if (this.counterSignerOfferings.length > 0) {
        this.formData.selectedOfferings = this.counterSignerOfferings.slice(0)
      }
    }
  }
</script>
